<template>
  <div class='notice'>
    <!--头部导航-->
    <div class="breadcrumb-area">
      <div class="row">
        <div class="col-md-12">
          <ol class="breadcrumb font-class">
            <li><a href="/#/home" v-on:click="sendMsg"><span class="fa fa-home"></span></a></li>
            <li class="active">公告</li>
          </ol>
        </div>
      </div>
    </div>

    <div class="content">
      <div class="top">
        <div>
          <div class="box" :data-attr="'公告'">
            <div class="box-content">
              <div v-for="item in noticeList" :key="item.title">
                <h6>{{item.title}}</h6>
                <div class="padding-p flex-p" v-for="value in item.content" :key="value.name">
                  <div>{{value.name}}</div>
                  <div class="right-tips"><a :href="value.downloadUrl" target="_blank">下载</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="box" :data-attr="'维护'">
            <div class="box-content">
              <div class="flex-p" v-for="item in newsList" :key="item.name">{{item.name}}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="bottom" style="margin-top: 40px;">
        <div class="box" :data-attr="'D3000A'">
          <div class="box-content">
            <div class="flex-p" v-for="(item, index) in D3000AList" :key="index">
              <div>{{index + 1}}.{{item.name}}</div>
              <div class="right-tips">
                <template v-if="item.downloadUrl != ''">
                  <a v-show="item.showPre" :href="item.preUrl" target="_blank">预览</a> <a
                     :href="item.downloadUrl">下载</a>
                </template>
                <template v-else>
                  <a v-show="item.showPre" @click="onClickNoUrl">预览</a> <a
                     @click="onClickNoUrl">下载</a>
                </template>
              </div>
            </div>
          </div>
        </div>
        <div class="box" :data-attr="'D3000B'" style="margin-top: 20px;">
          <div class="box-content">
            <div class="flex-p" v-for="(item, index) in D3000BList" :key="index">
              <div>{{index + 1}}.{{item.name}}</div>
              <div class="right-tips">
                <template v-if="item.downloadUrl != ''">
                  <a v-show="item.showPre" :href="item.preUrl" target="_blank">预览</a> <a
                     :href="item.downloadUrl">下载</a>
                </template>
                <template v-else>
                  <a v-show="item.showPre" @click="onClickNoUrl">预览</a> <a
                     @click="onClickNoUrl">下载</a>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "notice",
  props: {},
  data() {
    return {
      noticeList: [
        {
          title: "D3000A",
          content: [
            {
              name: "通用/爆破版arm最新版本：2.2.7",
              downloadUrl:
                "http://101.35.133.53:5555/web_site/web-update-v2.2.7.tgz",
              showPre: false,
            },
          ],
        },
        {
          title: "D3000B",
          content: [
            {
              name: "通用版arm最新版本：1.6.5",
              downloadUrl: "http://101.35.133.53:5555/web_site/D4000_v1.6.5.eb",
              showPre: false,
            },
            {
              name: "mqtt版arm最新版本：2.1.3",
              downloadUrl: "http://101.35.133.53:5555/web_site/D4000_v2.1.3.eb",
              showPre: false,
            },
            {
              name: "爆破版arm最新版本：1.7.1",
              downloadUrl: "http://101.35.133.53:5555/web_site/D4000_v1.7.1.eb",
              showPre: false,
            },
            {
              name: "fpga最新版本：1037（所有版本通用一个fpga）",
              downloadUrl:
                "http://101.35.133.53:5555/web_site/D4000_fpga_v1037.ez",
              showPre: false,
            },
          ],
        },
      ],
      newsList: [
        {
          name: "2021年12月3日 更新D3000B arm版本至1.6.5",
          downloadUrl: "",
          showPre: false,
        },
        {
          name: "2021年8月3日 更新D3000B arm版本至1.6.4",
          downloadUrl: "",
          showPre: false,
        },
      ],
      D3000AList: [
        {
          name: "标准/爆破版升级包",
          downloadUrl:
            "http://101.35.133.53:5555/web_site/web-update-v2.2.7.tgz",
          showPre: false,
        },
        {
          name: "标准/爆破版wave配置软件",
          downloadUrl: "http://101.35.133.53:5555/web_site/D3000A_wave.7z",
          showPre: false,
        },
        { name: "升级说明文档", preUrl: "", downloadUrl: "", showPre: true },
      ],
      D3000BList: [
        {
          name: "标准版升级包",
          downloadUrl: "http://101.35.133.53:5555/web_site/D4000_v1.6.5.eb",
          showPre: false,
        },
        {
          name: "爆破版本升级包",
          downloadUrl: "http://101.35.133.53:5555/web_site/D4000_v1.7.1.eb",
          showPre: false,
        },
        {
          name: "mqtt版升级包",
          downloadUrl: "http://101.35.133.53:5555/web_site/D4000_v2.1.3.eb",
          showPre: false,
        },
        {
          name: "通用fpga升级包",
          downloadUrl: "http://101.35.133.53:5555/web_site/D4000_fpga_v1037.ez",
          showPre: false,
        },
        {
          name: "通用wave配置软件",
          downloadUrl: "http://101.35.133.53:5555/web_site/D3000B_wave.7z",
          showPre: false,
        },
        {
          name: "升级说明文档",
          preUrl: "",
          downloadUrl: "",
          showPre: true,
        },
      ],
    };
  },
  computed: {},
  watch: {},
  methods: {
    onClickNoUrl() {
      alert("当前内容正在创建中，请耐心等待...");
    },
    sendMsg() {
      this.$emit("headCurrent", 0);
      window.sessionStorage.setItem("currentFirstIndex", 0);
    },
  },
  created() {},
  mounted() {},
};
</script>
<style scoped>
h6 {
  font-weight: bold;
}
.padding-p {
  padding: 0 10px;
}
.flex-p {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px dashed rgb(24, 82, 24);
}
.breadcrumb > li + li:before {
  padding: 0 5px;
  color: #000;
  content: ">";
  font-weight: lighter;
}

.breadcrumb > li span {
  font-size: 16px;
}

.content {
  padding: 20px;
}
.right-tips {
  width: 100px;
  text-align: right;
}
.top {
  display: flex;
  justify-content: space-between;
}
.top > div {
  padding: 10px 0;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}
.top > div:first-child {
  width: 60%;
}
.top > div:last-child {
  width: 40%;
}
.bottom {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.bottom > div {
  width: 50%;
}
.box {
  width: 95%;
  /* height: 220px; */
  border: 1px solid #379aac;
  position: relative;
  padding: 0 0;
  /* border-radius: 5px; */
}
.box::before {
  content: attr(data-attr);
  position: absolute;
  left: 10px;
  top: -12px;
  background-color: #ffffff;
  padding: 0 10px;
}
.box-content {
  width: calc(100% - 20px);
  /* height: calc(100% - 40px); */
  margin: 20px 10px;
  -ms-overflow-style: none;
  overflow: -moz-scrollbars-none;
  /* overflow-x: hidden;
  overflow-y: auto; */
  scrollbar-width: none;
}
.box-content::-webkit-scrollbar {
  width: 0 !important;
  height: 0 !important;
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/notice.vue